import { Link } from 'react-router-dom';

/** Liens légaux affichés sous les écrans d'authentification. */
export default function AuthLegalFooter() {
  return (
    <footer className="auth-legal-footer">
      <Link to="/confidentialite">Politique de confidentialité</Link>
      <span className="auth-legal-sep" aria-hidden="true">·</span>
      <Link to="/cgu">Conditions d&apos;utilisation</Link>
    </footer>
  );
}
